

import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`

* {
    box-sizing: border-box ;
    margin:0;
    padding:0;
    
 }
 body {
    background:#fff;
    color:hsl(192, 100%, 9%);
    font-family:"Graphik", sans-serif;
 }

 img {
    max-width:100%;
    object-fit:cover;
 }
 a {
   text-decoration:none;
 }
`;

export default GlobalStyles;